const drawio = {
	group: "block",
	draggable: true,
	attrs: {
		src: { default: null },
		title: { default: null },
		width: { default: null },
		height: { default: null },
	},
};

export default drawio;
